import React, {useState, useEffect, useContext} from 'react';
import {PageCover, Footer, MediaWithSearch} from 'components/section';
import {Pagenation} from 'components/items';


import firebase from 'library/firebase-config';
import 'firebase/firestore';
import { authContext } from 'shared/App';

const db = firebase.firestore();
const COLLECTION = 'medias';

const PAGERANGE = 2;

const Media = () => {
  const [data, setData] = useState([]);
  const [resultData, setResultData] = useState([]);
  const {setMediaLoading} = useContext(authContext);

  useEffect(()=>{
    setResultData(data);
  }, [data])

  // for pagenation---
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(12);
  const [minPage, setMinPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1 + PAGERANGE*2);
  const [pageCount, setPageCount] = useState();

  useEffect(() => {
    setPageCount(Math.ceil(resultData.length/postsPerPage))
  }, [resultData, postsPerPage])

  useEffect(() => {
    if(currentPage<PAGERANGE+1){
      // 1,2,3
      setMinPage(1);
      setMaxPage(PAGERANGE*2+1);

    }else if(currentPage> pageCount-PAGERANGE-1){
      // max-2, max-1, max
      setMinPage(pageCount-PAGERANGE*2);
      setMaxPage(pageCount);
    }else{
      setMinPage(currentPage-PAGERANGE)
      setMaxPage(currentPage+PAGERANGE)
    }
    
  }, [currentPage, resultData, pageCount])

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = resultData.slice(indexOfFirstPost, indexOfLastPost);
  const paginate =(pageNumber) => {
    window.scrollTo(0, 0);
    setCurrentPage(pageNumber)
  }
  const handlePageArrowClick = (right) => {

    if(right){
      if(currentPage<Math.ceil(resultData.length / postsPerPage)){
        paginate(currentPage + 1);
      }
    }else{
      if(currentPage>1){
        paginate(currentPage - 1);
      }
    }
  }

  // ----

  useEffect(()=> { 
    const initData = async () => {
      setMediaLoading(true);
      setData(await get());
      setMediaLoading(false);
    }
    initData();
  }, [setMediaLoading])



  const get = async () => {
    const result = [];
    const ref = await db.collection(COLLECTION).get();
    ref.forEach(el => {
      result.push({
        ...el.data(),
        id: el.id
      })
    })
    return result;
  }

 return (
  <div className="Media padding-cover">
    <PageCover 
      url = "media"
      title = "MEDIA & PRESS" 
      text = "언론에서 소개해주는 동구밭의 이야기를 만나보세요"
    />

    <MediaWithSearch data = {data} currentPosts={currentPosts} setResultData ={setResultData}/>
    <Pagenation minPage = {minPage} maxPage = {maxPage} handlePageArrowClick = {handlePageArrowClick} currentPage= {currentPage} postsPerPage = {postsPerPage} totalPosts = {resultData.length} paginate = {paginate}/>

    <Footer />
  </div>
 );
}

export default Media;